var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_959_2583",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_959_2583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 20.5C5.45 20.5 4.97917 20.3042 4.5875 19.9125C4.19583 19.5209 4 19.05 4 18.5V16.5C4 16.2167 4.09583 15.9792 4.2875 15.7875C4.47917 15.5959 4.71667 15.5 5 15.5C5.28333 15.5 5.52083 15.5959 5.7125 15.7875C5.90417 15.9792 6 16.2167 6 16.5V18.5H18V16.5C18 16.2167 18.0958 15.9792 18.2875 15.7875C18.4792 15.5959 18.7167 15.5 19 15.5C19.2833 15.5 19.5208 15.5959 19.7125 15.7875C19.9042 15.9792 20 16.2167 20 16.5V18.5C20 19.05 19.8042 19.5209 19.4125 19.9125C19.0208 20.3042 18.55 20.5 18 20.5H6ZM11 8.35005L9.125 10.225C8.925 10.425 8.6875 10.5209 8.4125 10.5125C8.1375 10.5042 7.9 10.4 7.7 10.2C7.51667 10 7.42083 9.76672 7.4125 9.50005C7.40417 9.23338 7.5 9.00005 7.7 8.80005L11.3 5.20005C11.4 5.10005 11.5083 5.02922 11.625 4.98755C11.7417 4.94588 11.8667 4.92505 12 4.92505C12.1333 4.92505 12.2583 4.94588 12.375 4.98755C12.4917 5.02922 12.6 5.10005 12.7 5.20005L16.3 8.80005C16.5 9.00005 16.5958 9.23338 16.5875 9.50005C16.5792 9.76672 16.4833 10 16.3 10.2C16.1 10.4 15.8625 10.5042 15.5875 10.5125C15.3125 10.5209 15.075 10.425 14.875 10.225L13 8.35005V15.5C13 15.7834 12.9042 16.0209 12.7125 16.2125C12.5208 16.4042 12.2833 16.5 12 16.5C11.7167 16.5 11.4792 16.4042 11.2875 16.2125C11.0958 16.0209 11 15.7834 11 15.5V8.35005Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.0d07f9599a527a6b26dabc101928c595.svg";
export { ForwardRef as ReactComponent };